import ActionTypes from "../../../constants";
import {} from "../types";
import { BusinessPartnerType } from "../../BusinessPartnerDetails/types";
import {
  SearchPayloadType,
  PaginationInfoType
} from "../../BusinessPartnerLists/types";

export interface fetchStewardBusinessPartnerListsActionType {
  type: typeof ActionTypes.FETCH_STEWARD_BUSINESSPARTNER_LISTS;
  payload: SearchPayloadType;
}
export interface fetchStewardBusinessPartnerListsSucceededActionType {
  type: typeof ActionTypes.FETCH_STEWARD_BUSINESSPARTNER_LISTS_SUCCEEDED;
  bpLists: BusinessPartnerType[];
  pageInfo: PaginationInfoType;
}

export const fetchStewardBusinessPartnerLists = (
  payload: SearchPayloadType
): fetchStewardBusinessPartnerListsActionType => ({
  type: ActionTypes.FETCH_STEWARD_BUSINESSPARTNER_LISTS,
  payload
});

export const fetchStewardBusinessPartnerListsSucceeded = (
  bpLists: BusinessPartnerType[],
  pageInfo: PaginationInfoType
): fetchStewardBusinessPartnerListsSucceededActionType => ({
  type: ActionTypes.FETCH_STEWARD_BUSINESSPARTNER_LISTS_SUCCEEDED,
  bpLists,
  pageInfo
});
